module.exports = __webpack_public_path__ + "049a824ecec3e148ae0fbcb0a2a5afbc.MP3";